import _toConsumableArray from "/opt/buildhome/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/opt/buildhome/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return a;
};

var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};

var __objRest = function __objRest(source, exclude) {
  var target = {};

  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }

  if (source != null && __getOwnPropSymbols) {
    var _iterator2 = _createForOfIteratorHelper(__getOwnPropSymbols(source)),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var prop = _step2.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }

  return target;
};

import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import { useStyles, chakra, forwardRef as forwardRef$1, useMultiStyleConfig, omitThemingProps, StylesProvider } from "@chakra-ui/system";
import { Collapse } from "@chakra-ui/transition";
import { dataAttr, cx } from "@chakra-ui/utils";
import { motion, AnimatePresence } from "framer-motion";
import * as React from "react";
import React__default from "react";
import { Flex, chakra as chakra$1, forwardRef, useStyles as useStyles$1, Spinner, useMediaQuery } from "@chakra-ui/react";
import { mode, anatomy, darken, lighten } from "@chakra-ui/theme-tools";
import { createIcon } from "@chakra-ui/icon";
var StepsContext = React.createContext({
  activeStep: 0
});

var useStepsContext = function useStepsContext() {
  return React.useContext(StepsContext);
};

var StepsProvider = function StepsProvider(_ref) {
  var value = _ref.value,
      children = _ref.children;

  var _React$useState = React.useState([]),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      widths = _React$useState2[0],
      setWidths = _React$useState2[1];

  var isError = value.state === "error";
  var isLoading = value.state === "loading";
  var isVertical = value.orientation === "vertical";
  var isLabelVertical = value.orientation !== "vertical" && value.labelOrientation === "vertical";
  return jsx(StepsContext.Provider, {
    value: __spreadProps(__spreadValues({}, value), {
      widths: widths,
      setWidths: setWidths,
      isError: isError,
      isLoading: isLoading,
      isVertical: isVertical,
      isLabelVertical: isLabelVertical
    }),
    children: children
  });
};

var Connector = React.memo(function (_ref2) {
  var index = _ref2.index,
      isCompletedStep = _ref2.isCompletedStep,
      children = _ref2.children,
      isLastStep = _ref2.isLastStep,
      hasLabel = _ref2.hasLabel;

  var _useStyles = useStyles(),
      connector = _useStyles.connector,
      stepIconContainer = _useStyles.stepIconContainer;

  var _useStepsContext = useStepsContext(),
      isVertical = _useStepsContext.isVertical,
      isLabelVertical = _useStepsContext.isLabelVertical,
      widths = _useStepsContext.widths;

  var getMargin = function getMargin() {
    if (isVertical) return "calc(".concat(stepIconContainer.width, " / 2)");
    if (!hasLabel) return 2;
    return 0;
  };

  var styles = React.useMemo(function () {
    var base = {
      ms: getMargin(),
      my: isVertical ? 2 : 0,
      ps: isVertical ? 4 : 0,
      me: isVertical || isLabelVertical ? 0 : 2,
      height: isVertical ? "auto" : "2px",
      alignSelf: isVertical ? "stretch" : "auto",
      borderTopWidth: isLastStep || isVertical ? 0 : "2px",
      borderInlineStartWidth: isLastStep || !isVertical ? 0 : "2px",
      minHeight: isLastStep || !isVertical ? "auto" : "1.5rem"
    };

    if (isLabelVertical) {
      return __spreadProps(__spreadValues({}, base), {
        position: "absolute",
        top: "calc(".concat(stepIconContainer.height, " / 2  - ").concat(base.height, " / 2)"),
        left: "calc(((".concat(widths == null ? void 0 : widths[index], "px + ").concat(stepIconContainer.width, ") / 2) + 8px)"),
        right: "calc((".concat(widths == null ? void 0 : widths[index + 1], "px - ").concat(stepIconContainer.width, ") / -2 + 8px)")
      });
    }

    return base;
  }, [widths, isLabelVertical, isVertical, stepIconContainer.height, stepIconContainer.width]);
  return jsx(chakra.div, {
    __css: __spreadValues(__spreadValues({}, styles), connector),
    "data-highlighted": dataAttr(isCompletedStep),
    children: isVertical && children
  });
});
var CheckIcon = createIcon({
  viewBox: "0 0 14 14",
  path: jsx("g", {
    fill: "currentColor",
    children: jsx("polygon", {
      points: "5.5 11.9993304 14 3.49933039 12.5 2 5.5 8.99933039 1.5 4.9968652 0 6.49933039"
    })
  })
});
var CloseIcon = createIcon({
  displayName: "CloseIcon",
  d: "M.439,21.44a1.5,1.5,0,0,0,2.122,2.121L11.823,14.3a.25.25,0,0,1,.354,0l9.262,9.263a1.5,1.5,0,1,0,2.122-2.121L14.3,12.177a.25.25,0,0,1,0-.354l9.263-9.262A1.5,1.5,0,0,0,21.439.44L12.177,9.7a.25.25,0,0,1-.354,0L2.561.44A1.5,1.5,0,0,0,.439,2.561L9.7,11.823a.25.25,0,0,1,0,.354Z"
});
var MotionFlex = motion(Flex);
var AnimatedCloseIcon = motion(CloseIcon);
var AnimatedSpan = motion(chakra$1.span);
var animationConfig = {
  transition: {
    duration: 0.25
  },
  exit: {
    scale: 0.5,
    opacity: 0
  },
  initial: {
    scale: 0.5,
    opacity: 0
  },
  animate: {
    scale: 1,
    opacity: 1
  }
};
var StepIcon = forwardRef(function (props, ref) {
  var _useStyles$ = useStyles$1(),
      icon = _useStyles$.icon,
      iconLabel = _useStyles$.iconLabel,
      label = _useStyles$.label;

  var isCompletedStep = props.isCompletedStep,
      isCurrentStep = props.isCurrentStep,
      isError = props.isError,
      isLoading = props.isLoading,
      CustomIcon = props.icon,
      index = props.index,
      CustomCheckIcon = props.checkIcon;

  var labelStyles = __spreadValues({
    fontWeight: "medium",
    color: mode("gray.900", "gray.100")(props),
    textAlign: "center",
    fontSize: "md"
  }, label);

  var Icon = React__default.useMemo(function () {
    return CustomIcon ? CustomIcon : null;
  }, [CustomIcon]);
  var Check = React__default.useMemo(function () {
    return CustomCheckIcon ? CustomCheckIcon : CheckIcon;
  }, [CustomCheckIcon]);
  return React__default.useMemo(function () {
    if (isCompletedStep) {
      return jsx(MotionFlex, __spreadProps(__spreadValues({}, animationConfig), {
        children: jsx(Check, {
          color: "white",
          style: icon
        })
      }), "check-icon");
    }

    if (isCurrentStep) {
      if (isError) return jsx(AnimatedCloseIcon, __spreadProps(__spreadValues({
        color: "white"
      }, animationConfig), {
        style: icon
      }), "icon");
      if (isLoading) return jsx(Spinner, {
        width: icon.width,
        height: icon.height
      });
    }

    if (Icon) return jsx(MotionFlex, __spreadProps(__spreadValues({}, animationConfig), {
      children: jsx(Icon, {
        style: icon
      })
    }), "step-icon");
    return jsx(AnimatedSpan, __spreadProps(__spreadValues({
      ref: ref,
      style: iconLabel,
      __css: labelStyles
    }, animationConfig), {
      children: (index || 0) + 1
    }), "label");
  }, [isCompletedStep, isCurrentStep, isError, isLoading, Icon, icon]);
});

var StepLabel = function StepLabel(_ref3) {
  var isCurrentStep = _ref3.isCurrentStep,
      opacity = _ref3.opacity,
      label = _ref3.label,
      description = _ref3.description;

  var _useStyles$2 = useStyles$1(),
      labelContainer = _useStyles$2.labelContainer,
      labelStyles = _useStyles$2.label,
      descriptionStyles = _useStyles$2.description;

  var _useStepsContext2 = useStepsContext(),
      isLabelVertical = _useStepsContext2.isLabelVertical;

  var shouldRender = !!label || !!description;
  return shouldRender ? jsxs(chakra$1.div, {
    "aria-current": isCurrentStep ? "step" : void 0,
    __css: __spreadValues({
      textAlign: isLabelVertical ? "center" : "left",
      alignItems: isLabelVertical ? "center" : "flex-start"
    }, labelContainer),
    children: [!!label && jsx(chakra$1.span, {
      __css: __spreadValues({
        mx: isLabelVertical ? 0 : 2,
        mt: isLabelVertical ? 1 : 0,
        opacity: opacity
      }, labelStyles),
      children: label
    }), !!description && jsx(chakra$1.span, {
      __css: __spreadValues({
        mx: isLabelVertical ? 0 : 2,
        mt: isLabelVertical ? 2 : 0,
        opacity: opacity
      }, descriptionStyles),
      children: description
    })]
  }) : null;
};

var Step = forwardRef$1(function (props, ref) {
  var _a = props,
      children = _a.children,
      description = _a.description,
      icon = _a.icon,
      index = _a.index,
      isCompletedStep = _a.isCompletedStep,
      isCurrentStep = _a.isCurrentStep,
      isLastStep = _a.isLastStep,
      label = _a.label,
      styleProps = __objRest(_a, ["children", "description", "icon", "index", "isCompletedStep", "isCurrentStep", "isLastStep", "label"]);

  var _useStepsContext3 = useStepsContext(),
      isVertical = _useStepsContext3.isVertical,
      isError = _useStepsContext3.isError,
      isLoading = _useStepsContext3.isLoading,
      isLabelVertical = _useStepsContext3.isLabelVertical,
      checkIcon = _useStepsContext3.checkIcon,
      onClickStep = _useStepsContext3.onClickStep,
      clickable = _useStepsContext3.clickable,
      setWidths = _useStepsContext3.setWidths,
      stepCount = _useStepsContext3.stepCount;

  var _useStyles2 = useStyles(),
      step = _useStyles2.step,
      stepContainer = _useStyles2.stepContainer,
      stepIconContainer = _useStyles2.stepIconContainer;

  var hasVisited = isCurrentStep || isCompletedStep;
  var opacity = hasVisited ? 1 : 0.8;

  var handleClick = function handleClick(index2) {
    if (clickable && onClickStep) {
      onClickStep(index2);
    }
  };

  var containerRef = React.useCallback(function (node) {
    if (node && setWidths) {
      setWidths(function (prev) {
        if (prev.length === stepCount) {
          return [node.offsetWidth || 0];
        }

        return [].concat(_toConsumableArray(prev), [node.offsetWidth || 0]);
      });
    }
  }, [stepIconContainer.width, stepIconContainer.height]);
  return jsx(Fragment, {
    children: jsxs(chakra.li, __spreadProps(__spreadValues({
      ref: ref,
      onClick: function onClick() {
        return handleClick(index);
      },
      "aria-disabled": !hasVisited,
      __css: __spreadValues({
        opacity: opacity,
        flexDir: isVertical ? "column" : "row",
        alignItems: isVertical || isLabelVertical ? "flex-start" : "center",
        flex: isLastStep && !isVertical ? "0 0 auto" : "1 0 auto",
        justifyContent: isLastStep && !isVertical ? "flex-end" : "flex-start",
        _hover: {
          cursor: clickable ? "pointer" : "default"
        }
      }, step)
    }, styleProps), {
      children: [jsxs(chakra.div, {
        ref: containerRef,
        __css: __spreadValues({
          flexDir: isLabelVertical ? "column" : "row"
        }, stepContainer),
        children: [jsx(chakra.div, {
          __css: stepIconContainer,
          "aria-current": isCurrentStep ? "step" : void 0,
          "data-invalid": dataAttr(isCurrentStep && isError),
          "data-highlighted": dataAttr(isCompletedStep),
          "data-clickable": dataAttr(clickable),
          children: jsx(AnimatePresence, {
            exitBeforeEnter: true,
            children: jsx(StepIcon, __spreadProps(__spreadValues({}, {
              index: index,
              isError: isError,
              isLoading: isLoading,
              isCurrentStep: isCurrentStep,
              isCompletedStep: isCompletedStep
            }), {
              icon: icon,
              checkIcon: checkIcon
            }))
          })
        }), jsx(StepLabel, __spreadValues({
          label: label,
          description: description
        }, {
          isCurrentStep: isCurrentStep,
          opacity: opacity
        }))]
      }), jsx(Connector, {
        index: index,
        isLastStep: isLastStep,
        hasLabel: !!label || !!description,
        isCompletedStep: isCompletedStep || false,
        children: jsx(Collapse, {
          style: {
            width: "100%"
          },
          in: isCurrentStep,
          children: (isCurrentStep || isCompletedStep) && children
        })
      })]
    }))
  });
});
var Steps = forwardRef$1(function (props, ref) {
  var styles = useMultiStyleConfig("Steps", props);

  var stepsStyles = __spreadValues({}, styles.steps);

  var _a = omitThemingProps(props),
      className = _a.className,
      activeStep = _a.activeStep,
      children = _a.children,
      orientationProp = _a.orientation,
      state = _a.state,
      responsive = _a.responsive,
      checkIcon = _a.checkIcon,
      onClickStep = _a.onClickStep,
      labelOrientation = _a.labelOrientation,
      rest = __objRest(_a, ["className", "activeStep", "children", "orientation", "state", "responsive", "checkIcon", "onClickStep", "labelOrientation"]);

  var childArr = React.Children.toArray(children);
  var stepCount = childArr.length;

  var renderHorizontalContent = function renderHorizontalContent() {
    if (activeStep <= childArr.length) {
      return React.Children.map(childArr[activeStep], function (node) {
        if (!React.isValidElement(node)) return;
        return React.Children.map(node.props.children, function (childNode) {
          return childNode;
        });
      });
    }

    return null;
  };

  var clickable = !!onClickStep;

  var _useMediaQuery = useMediaQuery("(max-width: 43em)"),
      _useMediaQuery2 = _slicedToArray(_useMediaQuery, 1),
      isMobile = _useMediaQuery2[0];

  var orientation = isMobile && responsive ? "vertical" : orientationProp;
  return jsx(StylesProvider, {
    value: styles,
    children: jsxs(StepsProvider, {
      value: {
        activeStep: activeStep,
        orientation: orientation,
        state: state,
        responsive: responsive,
        checkIcon: checkIcon,
        onClickStep: onClickStep,
        labelOrientation: labelOrientation,
        clickable: clickable,
        colorScheme: props.colorScheme,
        stepCount: stepCount
      },
      children: [jsx(chakra.ol, __spreadProps(__spreadValues({
        ref: ref,
        __css: __spreadValues({
          justifyContent: stepCount === 1 ? "flex-end" : "space-between",
          flexDir: orientation === "vertical" ? "column" : "row"
        }, stepsStyles),
        className: cx("chakra-steps", className)
      }, rest), {
        children: React.Children.map(children, function (child, i) {
          var _a2;

          var isCompletedStep = (_a2 = React.isValidElement(child) && child.props.isCompletedStep) != null ? _a2 : i < activeStep;
          var isLastStep = i === stepCount - 1;
          var isCurrentStep = i === activeStep;
          var stepProps = {
            index: i,
            isCompletedStep: isCompletedStep,
            isCurrentStep: isCurrentStep,
            isLastStep: isLastStep
          };

          if (React.isValidElement(child)) {
            return React.cloneElement(child, stepProps);
          }

          return null;
        })
      })), orientation === "horizontal" && renderHorizontalContent()]
    })
  });
});
Steps.defaultProps = {
  activeStep: 0,
  colorScheme: "green",
  orientation: "horizontal",
  responsive: true
};

function useSteps(_ref4) {
  var initialStep = _ref4.initialStep;

  var _React$useState3 = React.useState(initialStep),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      activeStep = _React$useState4[0],
      setActiveStep = _React$useState4[1];

  var nextStep = function nextStep() {
    setActiveStep(function (prev) {
      return prev + 1;
    });
  };

  var prevStep = function prevStep() {
    setActiveStep(function (prev) {
      return prev - 1;
    });
  };

  var reset = function reset() {
    setActiveStep(initialStep);
  };

  var setStep = function setStep(step) {
    setActiveStep(step);
  };

  return {
    nextStep: nextStep,
    prevStep: prevStep,
    reset: reset,
    setStep: setStep,
    activeStep: activeStep
  };
}

var parts = anatomy("steps").parts("connector", "description", "icon", "iconLabel", "label", "labelContainer", "step", "stepContainer", "stepIconContainer", "steps");
var baseStyleIcon = {
  strokeWidth: "2px"
};

var baseStyleLabel = function baseStyleLabel(props) {
  return {
    color: mode("gray.900", "gray.100")(props),
    fontWeight: "medium",
    textAlign: "center",
    fontSize: "md"
  };
};

var baseStyleDescription = function baseStyleDescription(props) {
  return {
    color: mode("gray.800", "gray.200")(props),
    marginTop: "-2px",
    textAlign: "center",
    fontSize: "sm"
  };
};

var baseStyleConnector = function baseStyleConnector(props) {
  var c = props.colorScheme;
  var inactiveColor = mode("gray.200", "gray.700")(props);
  var activeColor = mode("".concat(c, ".500"), "".concat(c, ".200"))(props);
  return {
    flex: 1,
    display: "flex",
    borderColor: inactiveColor,
    transitionProperty: "border-color",
    transitionDuration: "normal",
    _highlighted: {
      borderColor: activeColor
    }
  };
};

var baseStyleStepIconContainer = function baseStyleStepIconContainer(props) {
  var c = props.colorScheme;
  var inactiveColor = mode("gray.200", "gray.700")(props);
  var activeColor = "".concat(c, ".500");
  return {
    display: "flex",
    borderRadius: "50%",
    alignItems: "center",
    justifyContent: "center",
    bg: inactiveColor,
    borderColor: inactiveColor,
    transitionProperty: "background, border-color",
    transitionDuration: "normal",
    _activeStep: {
      bg: mode(darken(inactiveColor, 0.5), lighten(inactiveColor, 0.5))(props),
      borderColor: activeColor,
      _invalid: {
        bg: "red.500",
        borderColor: "red.500"
      }
    },
    _highlighted: {
      bg: activeColor,
      borderColor: activeColor
    },
    "&[data-clickable]:hover": {
      borderColor: activeColor
    }
  };
};

var baseStyle = function baseStyle(props) {
  return {
    connector: baseStyleConnector(props),
    description: baseStyleDescription(props),
    icon: baseStyleIcon,
    iconLabel: baseStyleLabel(props),
    label: baseStyleLabel(props),
    labelContainer: {
      display: "flex",
      flexDir: "column",
      justifyContent: "center"
    },
    step: {
      display: "flex",
      position: "relative"
    },
    stepContainer: {
      display: "flex",
      alignItems: "center"
    },
    stepIconContainer: baseStyleStepIconContainer(props),
    steps: {
      fontFamily: "heading",
      textAlign: "center",
      width: "100%",
      display: "flex",
      flex: 1
    }
  };
};

var sizes = {
  sm: {
    stepIconContainer: {
      width: "32px",
      height: "32px",
      borderWidth: "2px"
    },
    icon: {
      width: "14px",
      height: "14px"
    },
    label: {
      fontWeight: "medium",
      textAlign: "center",
      fontSize: "sm"
    },
    description: {
      fontWeight: "300",
      textAlign: "center",
      fontSize: "xs"
    }
  },
  md: {
    stepIconContainer: {
      width: "40px",
      height: "40px",
      borderWidth: "2px"
    },
    icon: {
      width: "18px",
      height: "18px"
    },
    label: {
      fontWeight: "medium",
      textAlign: "center",
      fontSize: "md"
    },
    description: {
      fontWeight: "300",
      textAlign: "center",
      fontSize: "sm"
    }
  },
  lg: {
    stepIconContainer: {
      width: "48px",
      height: "48px",
      borderWidth: "2px"
    },
    icon: {
      width: "22px",
      height: "22px"
    },
    label: {
      fontWeight: "bold",
      textAlign: "center",
      fontSize: "lg"
    },
    description: {
      fontWeight: "300",
      textAlign: "center",
      fontSize: "md"
    }
  }
};
var defaultProps = {
  size: "md",
  colorScheme: "green"
};
var StepsStyleConfig = {
  parts: parts.keys,
  baseStyle: baseStyle,
  sizes: sizes,
  defaultProps: defaultProps
};
export { Step, Steps, StepsStyleConfig, useSteps };